import { Link, useLocation } from 'react-router-dom';
import { Home, Package, MessageCircle, DollarSign, Settings } from 'lucide-react';
import { useOrdersStore } from '@/store/orders';

export default function BottomNav() {
  const location = useLocation();
  const activeOrder = useOrdersStore((state) => state.activeOrder);

  const navItems = [
    { path: '/home', icon: Home, label: 'Home' },
    { path: '/orders', icon: Package, label: 'Orders', badge: activeOrder ? 1 : 0 },
    { path: '/chat', icon: MessageCircle, label: 'Chat' },
    { path: '/earnings', icon: DollarSign, label: 'Earnings' },
    { path: '/settings', icon: Settings, label: 'Settings' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path || 
                           (item.path === '/chat' && location.pathname.startsWith('/chat'));

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full relative ${
                isActive ? 'text-primary' : 'text-muted-foreground'
              }`}
            >
              <div className="relative">
                <Icon className="w-6 h-6" />
                {item.badge && item.badge > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full min-w-[20px] h-5 flex items-center justify-center font-bold px-1.5">
                    {item.badge}
                  </span>
                )}
              </div>
              <span className="text-xs mt-1">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

